<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="userGroup.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Пользователи</label>
            <crm-user-multi-select
              [(selectedUsers)]="userGroup.users"
              [isError]="$any(errors?.users)"
              [isFloatLabel]="false"
              [withBots]="true"
              appendTo="body">
            </crm-user-multi-select>
            <small
              *ngIf="errors?.users"
              class="p-error"
              >{{ errors.users | join }}</small
            >
          </div>

          <div
            *ngIf="userGroup.users?.length"
            class="field">
            <label class="font-medium">Руководители группы</label>
            <crm-table
              styleClass="sticky-header card-table p-datatable-sm p-datatable-gridlines"
              name="user-group"
              [columns]="columns">
              <ng-template #rowTemplate>
                <ng-container *ngFor="let user of userGroup.users">
                  <tr *ngIf="toUser(user) as user">
                    <td>
                      {{ user?.profile?.name }}
                    </td>
                    <td>
                      <p-checkbox
                        [(ngModel)]="user.isSupervisor"
                        [binary]="true"></p-checkbox>
                    </td>
                  </tr>
                </ng-container>
              </ng-template>
            </crm-table>
          </div>
        </div>
      </p-card>
    </div>

    <div
      *ngIf="(form$ | async)?.isEdit"
      class="col-12">
      <crm-user-group-history [index]="index"></crm-user-group-history>
    </div>
  </div>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <button
        pButton
        [label]="saveButtonLabel"
        class="p-button-success"
        (click)="saveUserGroup()"></button>
      <button
        *ngIf="(form$ | async)?.isShowDelete"
        pButton
        label="Удалить"
        class="p-button-danger p-button-text"
        (click)="deleteUserGroup()"></button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
